/* global sentryKey, sentrySampleRate, RELEASE */
import * as Sentry from '@sentry/browser';
/*
    List of errors that will be prevented from being sent to sentry.
    These errors are mostly things that are out of our control
 */
const filteredErrors = [
  "Failed to read the 'localStorage' property from 'Window'",
];

const setupSentry = () => {
  // The none is coming from the setting as we cannot have empty settings
  if (
    typeof sentryKey !== 'undefined' &&
    sentryKey !== 'none' &&
    !window.location.href.match(/dev./)
  ) {
    let env = 'prod';
    const location = window.location.hostname;
    if (location.match(/k8s/)) env = 'staging';
    else if (location.match(/beta/)) env = 'beta';
    Sentry.init({
      dsn: sentryKey,
      environment: env,
      sampleRate: sentrySampleRate,
      release: RELEASE,
      ignoreErrors: [
        'Non-Error promise rejection captured',
        'Unexpected token < in JSON',
      ],
      beforeSend(event, hint) {
        const error = hint.originalException;
        if (error && error.message && filteredErrors.includes(error.message))
          return null;

        return event;
      },
    });
  }
};
/*
    Logs an exception to sentry.
    tags: Object with the different tags to enrich the event
    extra: Object containing extra information that we want to send to sentry
*/
const logException = (err, tags = null, extra = null) => {
  Sentry.withScope((scope) => {
    tags && scope.setTags(tags);
    extra && scope.setExtras(extra);
    Sentry.captureException(new Error(err));
  });
};

const logError = (message) => {
  Sentry.captureException(message);
};

export { setupSentry, logError, logException };
